// extracted by mini-css-extract-plugin
module.exports = {"entries":"entries___3DIp7","loader":"loader___1BE0X"};